import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// components
import ErrorView from '../../components/ErrorMsg';

// actions
import { deleteErrorMessages } from '../../reducers/ErrorMsg/actions';

const ErrorMsgPropTypes = {
  error: PropTypes.bool.isRequired, // If there is an error (True|False)
  errorMsg: PropTypes.string.isRequired, // The message to display to the user
  dispatchDeleteErrorMessages: PropTypes.func.isRequired, // Removes all error messages from Redux store
};

const ErrorMsgDefaultProps = {};

class ErrorMsg extends Component {
  constructor(props) {
    super(props);
    this.clearErrorMessages = this.clearErrorMessages.bind(this);
  }

  clearErrorMessages() {
    const { dispatchDeleteErrorMessages } = this.props;
    dispatchDeleteErrorMessages();
  }

  render() {
    const { error, errorMsg } = this.props;
    return <ErrorView errorMsg={errorMsg} error={error} handleClick={this.clearErrorMessages} />;
  }
}

ErrorMsg.propTypes = ErrorMsgPropTypes;

ErrorMsg.defaultProps = ErrorMsgDefaultProps;

const mapStateToProps = state => ({
  error: state.ErrorMsg.error,
  errorMsg: state.ErrorMsg.errorMsg,
});

const mapDispatchToProps = dispatch => ({
  dispatchDeleteErrorMessages: () => {
    dispatch(deleteErrorMessages());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorMsg);
